type Cache = Record<string, unknown>;

/**
 * Return the boolean result from callback fn with cache controllers.
 * 
 * Ex. `const isCached => withCache((cache) => cache.exists('key', 'value'))`
 */
export const withCache = (() => {
  const cache: Cache = {};

  const reset = () => Object.keys(cache).forEach(key => (cache[key] = undefined));
  const set = <T>(key: string, value: T) => (cache[key] = value);
  const get = (key: string) => cache[key];
  const exists = <T>(key: string, value: T) => cache[key] === value;

  const controller = {
    reset,
    set,
    get,
    exists
  };

  return (fn: (cacheController: typeof controller) => boolean) => fn(controller);
})();
